<template>
  <div class='page-layout-body' :class="{'fixed-page': !showFooter}">
    <top-header></top-header>
    <home-main></home-main>
    <Footer v-if="showFooter"/>
  </div>
</template>
<script>
import TopHeader from "./common/top-header";
import HomeMain from "./common/main";
import Footer from './common/footer'

  export default {
    data() {
      return {
        collapsed: false,
      };
    },
    computed: {
      showFooter() {
        return this.$store.state.showFooter
      },
    },
    components: {
      HomeMain,
      TopHeader,
      Footer,
    }
  };
</script>

<style lang="scss" scoped>
.fixed-page{
  display: flex;
  flex-direction: column;
}
</style>
